import React from "react";
import axios from 'axios'
import FontAwesome from 'react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import Table from '../../components/Table';
import FromToForm from "../../components/Forms/FromToForm";
import ExcelExport from '../../components/ExcelExport/index';

const tableOptions = {
  showPagination: true,
  showPageSizeOptions: true,
  showPageJump: true,
  collapseOnSortingChange: true,
  collapseOnPageChange: true,
  collapseOnDataChange: true,
  freezeWhenExpanded: false,
  filterable: true,
  sortable: true,
  resizable: true,
  defaultPageSize: 5
};

class PointsStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      from: null,
      to: null,
      pointAccounts: [],
      loaded: false,
      columns: [
        {
          Header: 'Uživatel',
          accessor: 'userId.fullname'
        },
        {
          Header: 'E-mail',
          accessor: 'userId.email'
        },
        {
          Header: 'Počet bodů',
          accessor: 'balance'
        }
      ],
      tableOptions: {
        ...tableOptions,
        defaultSorted:[{
          id: 'balance',
          desc: true
        }]
      }
    };
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active) {
      if (!this.state.loaded) {
        this.getUsers();
        this.setState({
          loaded: true,
        });
      }
    }
  }

  getUsers() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      },
      params: {
        balance_from: this.state.from,
        balance_to: this.state.to
      }
    };
    axios.get(this.props.api.stats.pointAccountsBalance, config)
      .then((result) => {
        if (!this._calledComponentWillUnmount) {
          this.setState({
            pointAccounts: result.data.map((row) => {
              return {
                ...row,
                userId: {
                  ...row.userId,
                  fullname: row.userId
                    ? (row.userId.firstname && row.userId.surname
                      ? `${row.userId.nickname} (${row.userId.firstname} ${row.userId.surname})`
                      : row.userId.nickname)
                    : ''
                }
              }
            }),
            tableOptions: {
              ...this.state.tableOptions,
              loading: false,
            }
          });
        }
      })
      .catch((error) => {
        console.error('Error axios:', error);
      });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      tableOptions: {
        ...this.state.tableOptions,
        loading: true
      }
    });
    this.getUsers();
  }

  handleChangeFrom(event) {
    this.setState({ from: event.target.value });
  }

  handleChangeTo(event) {
    this.setState({ to: event.target.value });
  }

  render() {
    const { columns, pointAccounts, tableOptions } = this.state;
    const excelData = {
      fileName: 'Bodové statistiky uživatelů',
      sheets: [
        {
          name: 'Bodové statistiky uživatelů',
          columns: [...columns],
          data: [...pointAccounts],
        }
      ],
    };

    const excelElement = (
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-export-pointAccounts">Export</Tooltip>}>
        <FontAwesome name="file-excel-o" size="2x" className="cursor-p" />
      </OverlayTrigger>
    );

    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>Bodové statistiky uživatelů</h2>
          <FromToForm from="Body od:" to="Body do:" handleSubmit={this.handleSubmit}
                      handleChangeFrom={this.handleChangeFrom} handleChangeTo={this.handleChangeTo} />
          <div className="clearfix" />
        </div>
        <div className="x-content">
          <div className="export">
            <ExcelExport element={excelElement} data={excelData}/>
          </div>
          <Table
            columns={columns}
            data={pointAccounts}
            tableOptions={tableOptions}
            defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
          />
        </div>
      </div>
    )
  }
}

class MoneyStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      from: null,
      to: null,
      moneyAccounts: [],
      loaded: false,
      columns: [
        {
          Header: 'Uživatel',
          accessor: 'userId.fullname'
        },
        {
          Header: 'E-mail',
          accessor: 'userId.email'
        },
        {
          Header: 'Zůstatek',
          accessor: 'balance'
        }
      ],
      tableOptions: {
        ...tableOptions,
        defaultSorted:[{
          id: 'balance',
          desc: true
        }]
      }
    };
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active) {
      if (!this.state.loaded) {
        this.getUsers();
        this.setState({
          loaded: true,
        });
      }
    }
  }

  getUsers() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      },
      params: {
        balance_from: this.state.from,
        balance_to: this.state.to
      }
    };
    axios.get(this.props.api.stats.moneyAccountsBalance, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        this.setState({
          moneyAccounts: result.data.map((row) => {
            return {
              ...row,
              userId: {
                ...row.userId,
                fullname: row.userId
                  ? (row.userId.firstname && row.userId.surname
                    ? `${row.userId.nickname} (${row.userId.firstname} ${row.userId.surname})`
                    : row.userId.nickname)
                  : ''
              }
            }
          }),
          tableOptions: {
            ...this.state.tableOptions,
            loading: false
          }
        });
      }
    }).catch((error) => {
      console.error('Error axios:', error);
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      tableOptions: {
        ...this.state.tableOptions,
        loading: true
      }
    });
    this.getUsers();
  }

  handleChangeFrom(event) {
    this.setState({ from: event.target.value });
  }

  handleChangeTo(event) {
    this.setState({ to: event.target.value });
  }

  render() {
    const { columns, moneyAccounts, tableOptions } = this.state;
    const excelData = {
      fileName: 'Finanční statistiky uživatelů',
      sheets: [
        {
          name: 'Finanční statistiky uživatelů',
          columns: [...columns],
          data: [...moneyAccounts],
        }
      ],
    };

    const excelElement = (
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-export-moneyAccounts">Export</Tooltip>}>
        <FontAwesome name="file-excel-o" size="2x" className="cursor-p" />
      </OverlayTrigger>
    );

    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>Finanční statistiky uživatelů</h2>
          <FromToForm from="Peníze od:" to="Peníze do:" handleSubmit={this.handleSubmit}
                      handleChangeFrom={this.handleChangeFrom} handleChangeTo={this.handleChangeTo} />
          <div className="clearfix" />
        </div>
        <div className="x-content">
          <div className="export">
            <ExcelExport element={excelElement} data={excelData}/>
          </div>
          <Table
            columns={columns}
            data={moneyAccounts}
            tableOptions={tableOptions}
            defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
          />
        </div>
      </div>
    );
  }
}

class CorrectnessStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      from: 0,
      to: 100,
      correctness: [],
      loaded: false,
      columns: [
        {
          Header: 'Uživatel',
          accessor: 'userInfo.fullname'
        },
        {
          Header: 'E-mail',
          accessor: 'userInfo.email'
        },
        {
          Header: 'Správných odpovědí',
          accessor: 'correct'
        },
        {
          Header: 'Celkem',
          accessor: 'totalCount'
        },
        {
          Header: 'Správnost v %',
          accessor: 'ratioPercent'
        }
      ],
      tableOptions: {
        ...tableOptions,
        defaultSorted:[{
          id: 'ratioPercent',
          desc: true
        }]
      }
    };
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active) {
      if (!this.state.loaded) {
        this.getUsers();
        this.setState({
          loaded: true,
        });
      }
    }
  }

  getUsers() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      },

    };
    axios.post(this.props.api.stats.uqaLogsRatio, {
      from: this.state.from,
      to: this.state.to,
      cache: true,
    }, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        this.setState({
          correctness: result.data.map((row) => {
            return {
              ...row,
              userInfo: {
                ...row.userInfo,
                fullname: row.userInfo
                  ? (row.userInfo.firstname && row.userInfo.surname
                    ? `${row.userInfo.nickname} (${row.userInfo.firstname} ${row.userInfo.surname})`
                    : row.userInfo.nickname)
                  : ''
              }
            }
          }),
          tableOptions: {
            ...this.state.tableOptions,
            loading: false
          }
        });
      }
    }).catch((error) => {
      console.error('Error axios:', error);
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      tableOptions: {
        ...this.state.tableOptions,
        loading: true
      }
    });
    this.getUsers();
  }

  handleChangeFrom(event) {
    this.setState({ from: event.target.value });
  }

  handleChangeTo(event) {
    this.setState({ to: event.target.value });
  }

  render() {
    const { columns, correctness, tableOptions } = this.state;
    const excelData = {
      fileName: 'Statistiky odpovědí',
      sheets: [
        {
          name: 'Statistiky odpovědí',
          columns: [...columns],
          data: [...correctness],
        }
      ],
    };

    const excelElement = (
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-export-correctness">Export</Tooltip>}>
        <FontAwesome name="file-excel-o" size="2x" className="cursor-p" />
      </OverlayTrigger>
    );

    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>Statistiky odpovědí</h2>
          <FromToForm from="Správnost od:" to="Správnost do:" handleSubmit={this.handleSubmit}
                      handleChangeFrom={this.handleChangeFrom} handleChangeTo={this.handleChangeTo} />
          <div className="clearfix" />
        </div>
        <div className="x-content">
          <div className="export">
            <ExcelExport element={excelElement} data={excelData}/>
          </div>
          <Table
            columns={columns}
            data={correctness}
            tableOptions={tableOptions}
            defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
          />
        </div>
      </div>
    );
  }
}

class UsersStats extends React.Component {
  render() {
    return (
      <div id="usersStats-page">
        <PointsStats {...this.props} />
        <MoneyStats {...this.props} />
        <CorrectnessStats {...this.props} />
      </div>
    );
  }
}

export default UsersStats;



/** WEBPACK FOOTER **
 ** ./src/containers/Statistics/usersStats.js
 **/